// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150647/js/" + chunkId + "." + {"44":"64b87d2d","225":"c2540149","481":"379cc470","486":"c9a63bb8","770":"cd65133c"}[chunkId] + ".0.23054924946553756.chunk.js";
};